import { gql } from '@apollo/client';

export const ENGAGEMENT_CONTENT = gql`
  query EngagementContent($input: EngagementContentInput) {
    engagementContent(input: $input) {
      fetchedAt
      playlistId
      weekStartDate
      items {
        id
        videoId
        videoUrl
        thumbnailUrl
        title
        source
        duration
        tags
      }
    }
  }
`;
